module.exports = __webpack_public_path__ + "static/media/award02.ff49ca57.png";